/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto } from './WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto';
import {
    WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSON,
    WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSONTyped,
    WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoToJSON,
} from './WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto';

/**
 * 
 * @export
 * @interface WebApiIntegrationsDtoPingPaymentPaymentReportDto
 */
export interface WebApiIntegrationsDtoPingPaymentPaymentReportDto {
    /**
     * 
     * @type {Array<WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto>}
     * @memberof WebApiIntegrationsDtoPingPaymentPaymentReportDto
     */
    payments?: Array<WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDto> | null;
}

/**
 * Check if a given object implements the WebApiIntegrationsDtoPingPaymentPaymentReportDto interface.
 */
export function instanceOfWebApiIntegrationsDtoPingPaymentPaymentReportDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportDtoFromJSON(json: any): WebApiIntegrationsDtoPingPaymentPaymentReportDto {
    return WebApiIntegrationsDtoPingPaymentPaymentReportDtoFromJSONTyped(json, false);
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiIntegrationsDtoPingPaymentPaymentReportDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'payments': !exists(json, 'payments') ? undefined : (json['payments'] === null ? null : (json['payments'] as Array<any>).map(WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoFromJSON)),
    };
}

export function WebApiIntegrationsDtoPingPaymentPaymentReportDtoToJSON(value?: WebApiIntegrationsDtoPingPaymentPaymentReportDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'payments': value.payments === undefined ? undefined : (value.payments === null ? null : (value.payments as Array<any>).map(WebApiIntegrationsDtoPingPaymentPaymentReportPaymentDtoToJSON)),
    };
}

